import { render, staticRenderFns } from "./EditUser.vue?vue&type=template&id=7988e830&"
import script from "./EditUser.vue?vue&type=script&setup=true&lang=js&"
export * from "./EditUser.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EditUser.vue?vue&type=style&index=0&id=7988e830&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports